import React from 'react'

export const AppState = React.createContext({})



// WEBPACK FOOTER //
// ./src/helpers/context.js